"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable:no-console */

var ow_1 = require("ow");

var LiveLogConfig_1 = require("./config/LiveLogConfig");

var LogLevel_1 = require("./config/LogLevel");

var LogMetadata_1 = require("./config/LogMetadata");

var StaticConfig_1 = require("./config/StaticConfig");

var ParseLogMsg_1 = require("./parse/ParseLogMsg");
/**
 * Logging levels conforms NPM logging levels
 */


var AbstractUniverseLog =
/*#__PURE__*/
function () {
  function AbstractUniverseLog(props) {
    var _this = this;

    _classCallCheck(this, AbstractUniverseLog);

    this.instanceMetadata = LogMetadata_1.LogMetadata.EMPTY_METADATA;

    if (props.metadata) {
      ow_1.default(props.metadata, "metadata", ow_1.default.object);
      this.instanceMetadata = props.metadata;
    }

    if (props.logFn) {
      this.logFn = props.logFn;
    } else {
      this.logFn = StaticConfig_1.StaticConfig.DEFAULT_LOG_FN;
    }

    ow_1.default(this.logFn, "logFn", ow_1.default.function);
    ow_1.default(props.levelEnvs, "levelEnvs", ow_1.default.object);
    this.liveConfig = new LiveLogConfig_1.LiveLogConfig(props.levelEnvs, function (msg) {
      return _this.logFn(msg);
    });
  }

  _createClass(AbstractUniverseLog, [{
    key: "init",
    value: function init(logLevelEnvs) {
      if (logLevelEnvs) {
        this.liveConfig.setLevelEvaluationEnvNames(logLevelEnvs);
      }

      this.reevaluateConfigIfRequired();
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.liveConfig.getLevel();
    }
  }, {
    key: "getFormatName",
    value: function getFormatName() {
      return this.liveConfig.getFormat().getName();
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      return Object.assign({}, this.instanceMetadata, this.liveConfig.getMetadata());
    }
  }, {
    key: "isDebug",
    value: function isDebug() {
      var levelThreshold = LogLevel_1.LogLevel.LEVELS_VALUES[this.getLevel()];
      return levelThreshold >= LogLevel_1.LogLevel.LEVELS_VALUES.debug;
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len = arguments.length, msg = new Array(_len), _key = 0; _key < _len; _key++) {
        msg[_key] = arguments[_key];
      }

      this.doLog(LogLevel_1.LogLevel.error, msg);
    }
  }, {
    key: "errorGen",
    value: function errorGen(genFn) {
      this.doEfficientLog(LogLevel_1.LogLevel.error, genFn);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, msg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        msg[_key2] = arguments[_key2];
      }

      this.doLog(LogLevel_1.LogLevel.warn, msg);
    }
  }, {
    key: "warnGen",
    value: function warnGen(genFn) {
      this.doEfficientLog(LogLevel_1.LogLevel.warn, genFn);
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, msg = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        msg[_key3] = arguments[_key3];
      }

      this.doLog(LogLevel_1.LogLevel.info, msg);
    }
  }, {
    key: "infoGen",
    value: function infoGen(genFn) {
      this.doEfficientLog(LogLevel_1.LogLevel.info, genFn);
    }
  }, {
    key: "http",
    value: function http() {
      for (var _len4 = arguments.length, msg = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        msg[_key4] = arguments[_key4];
      }

      this.doLog(LogLevel_1.LogLevel.http, msg);
    }
  }, {
    key: "httpGen",
    value: function httpGen(genFn) {
      this.doEfficientLog(LogLevel_1.LogLevel.http, genFn);
    }
  }, {
    key: "verbose",
    value: function verbose() {
      for (var _len5 = arguments.length, msg = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        msg[_key5] = arguments[_key5];
      }

      this.doLog(LogLevel_1.LogLevel.verbose, msg);
    }
  }, {
    key: "verboseGen",
    value: function verboseGen(genFn) {
      this.doEfficientLog(LogLevel_1.LogLevel.verbose, genFn);
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len6 = arguments.length, msg = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        msg[_key6] = arguments[_key6];
      }

      this.doLog(LogLevel_1.LogLevel.debug, msg);
    }
  }, {
    key: "debugGen",
    value: function debugGen(genFn) {
      this.doEfficientLog(LogLevel_1.LogLevel.debug, genFn);
    }
  }, {
    key: "silly",
    value: function silly() {
      for (var _len7 = arguments.length, msg = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        msg[_key7] = arguments[_key7];
      }

      this.doLog(LogLevel_1.LogLevel.silly, msg);
    }
  }, {
    key: "sillyGen",
    value: function sillyGen(genFn) {
      this.doEfficientLog(LogLevel_1.LogLevel.silly, genFn);
    }
    /**
     * Calls generator fn only if logging level is reached.
     */

  }, {
    key: "doEfficientLog",
    value: function doEfficientLog(level, msgGeneratorFn) {
      this.reevaluateConfigIfRequired();
      var levelThreshold = LogLevel_1.LogLevel.LEVELS_VALUES[this.getLevel()];
      var msgLevel = LogLevel_1.LogLevel.LEVELS_VALUES[level];

      if (msgLevel <= levelThreshold) {
        this.doLog(level, msgGeneratorFn());
      }
    }
  }, {
    key: "doLog",
    value: function doLog(level) {
      for (var _len8 = arguments.length, msgsObjs = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        msgsObjs[_key8 - 1] = arguments[_key8];
      }

      this.reevaluateConfigIfRequired();

      if (msgsObjs.length === 0) {
        return;
      }

      if (msgsObjs.length === 1 && Array.isArray(msgsObjs[0])) {
        msgsObjs = msgsObjs[0];
      }

      if (LogLevel_1.LogLevel.isLessOrEquallyVerbose({
        level: level,
        threshold: this.getLevel()
      })) {
        var parsedMessage = ParseLogMsg_1.ParseLogMsg.parse(level, msgsObjs);
        var formattedMessage = this.liveConfig.getFormat().format(parsedMessage, this.getMetadata());
        this.rawWriteToLog(formattedMessage);
      }
    }
  }, {
    key: "rawWriteToLog",
    value: function rawWriteToLog(msg) {
      this.logFn(msg);
    }
  }, {
    key: "reevaluateConfigIfRequired",
    value: function reevaluateConfigIfRequired() {
      this.liveConfig.evaluateIfRequired();
    }
  }]);

  return AbstractUniverseLog;
}();

AbstractUniverseLog.level = LogLevel_1.LogLevel;
exports.AbstractUniverseLog = AbstractUniverseLog;